// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2D_HL","label":"CategoryService_label__1Aju_","location":"CategoryService_location__1ScQ0"};